import { Layout, restartBtnBounds, debugBtnBounds } from './renderer';

export interface TapEvent {
  row: number;
  col: number;
  x: number;   // пиксели относительно canvas
  y: number;
}

export function attachTapListener(
  canvas: HTMLCanvasElement,
  onTap: (e: TapEvent) => void
): void {
  let lastTouch: { x: number; y: number } | null = null;

  function toCanvasCoords(clientX: number, clientY: number): { x: number; y: number } {
    const rect = canvas.getBoundingClientRect();
    return {
      x: clientX - rect.left,
      y: clientY - rect.top,
    };
  }

  canvas.addEventListener('touchstart', e => {
    e.preventDefault();
    const t = e.touches[0];
    lastTouch = toCanvasCoords(t.clientX, t.clientY);
  }, { passive: false });

  canvas.addEventListener('touchend', e => {
    e.preventDefault();
    if (!lastTouch) return;
    const { x, y } = lastTouch;
    lastTouch = null;
    onTap({ row: -1, col: -1, x, y }); // row/col вычисляются в main
  }, { passive: false });

  canvas.addEventListener('click', e => {
    const { x, y } = toCanvasCoords(e.clientX, e.clientY);
    onTap({ row: -1, col: -1, x, y });
  });
}

// ── Хит-тест: находится ли тап внутри доски и какая клетка ───────────────
export function tapToCell(
  x: number, y: number,
  layout: Layout
): { row: number; col: number } | null {
  const { boardX, boardY, boardSize, cell } = layout;
  if (x < boardX || x > boardX + boardSize) return null;
  if (y < boardY || y > boardY + boardSize) return null;
  const col = Math.floor((x - boardX) / cell);
  const row = Math.floor((y - boardY) / cell);
  return { row, col };
}

// ── Хит-тест на кнопку рестарта ───────────────────────────────────────────
export function tapOnRestart(
  x: number, y: number,
  layout: Layout, W: number, H: number
): boolean {
  const { cx, cy, r } = restartBtnBounds(layout, W, H);
  return (x - cx) ** 2 + (y - cy) ** 2 <= (r + 10) ** 2;
}

// ── Хит-тест на кнопку debug ─────────────────────────────────────────────
export function tapOnDebug(
  x: number, y: number,
  layout: Layout, W: number, H: number
): boolean {
  const { cx, cy, r } = debugBtnBounds(layout, W, H);
  return (x - cx) ** 2 + (y - cy) ** 2 <= (r + 10) ** 2;
}

// ── Хит-тест на кубик ─────────────────────────────────────────────────────
export function tapOnDice(
  x: number, y: number,
  layout: Layout, W: number, H: number
): boolean {
  const uiY     = layout.boardY + layout.boardSize + layout.cell * 0.3;
  const uiH     = H - uiY - layout.cell * 0.2;
  const diceSize = Math.min(layout.cell * 2.2, uiH * 0.7);
  const diceCx   = W / 2;
  const diceCy   = uiY + uiH / 2;
  return (
    x >= diceCx - diceSize / 2 - 8 &&
    x <= diceCx + diceSize / 2 + 8 &&
    y >= diceCy - diceSize / 2 - 8 &&
    y <= diceCy + diceSize / 2 + 8
  );
}
